var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-reports" }, [
    _c("div", { staticClass: "reports-header" }, [
      _c("h2", { staticClass: "reports-title" }, [_vm._v("Görev Raporları")]),
      _vm._v(" "),
      _c("div", { staticClass: "header-controls" }, [
        _c(
          "div",
          { staticClass: "workflow-selector" },
          [
            _c(
              "a-select",
              {
                staticStyle: { width: "300px" },
                attrs: {
                  placeholder: "Workflow seçiniz",
                  disabled: _vm.isLoading,
                },
                on: { change: _vm.handleWorkflowChange },
                model: {
                  value: _vm.selectedWorkflowId,
                  callback: function ($$v) {
                    _vm.selectedWorkflowId = $$v
                  },
                  expression: "selectedWorkflowId",
                },
              },
              _vm._l(_vm.availableWorkflows, function (workflow) {
                return _c(
                  "a-select-option",
                  { key: workflow.value, attrs: { value: workflow.value } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(workflow.label) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.selectedWorkflowId
          ? _c(
              "div",
              { staticClass: "filter-controls" },
              [
                _c(
                  "a-button",
                  {
                    class: { active: _vm.hasActiveFilters },
                    attrs: { type: "default" },
                    on: {
                      click: function ($event) {
                        _vm.showFilters = !_vm.showFilters
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("tune"),
                    ]),
                    _vm._v(
                      "\n                    Filtreler\n                    "
                    ),
                    _vm.hasActiveFilters
                      ? _c("span", { staticClass: "filter-badge" }, [
                          _vm._v(_vm._s(_vm.activeFilterCount)),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.hasActiveFilters
                  ? _c(
                      "a-button",
                      {
                        staticStyle: { padding: "4px 8px" },
                        attrs: { type: "link" },
                        on: { click: _vm.clearFilters },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("clear"),
                        ]),
                        _vm._v(
                          "\n                    Temizle\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.showFilters && _vm.selectedWorkflowId
      ? _c("div", { staticClass: "filters-panel" }, [
          _c("div", { staticClass: "filter-row" }, [
            _c(
              "div",
              { staticClass: "filter-group" },
              [
                _c("label", { staticClass: "filter-label" }, [
                  _vm._v("Tarih Aralığı:"),
                ]),
                _vm._v(" "),
                _c("a-range-picker", {
                  staticStyle: { width: "280px" },
                  attrs: {
                    placeholder: "Başlangıç - Bitiş",
                    format: "DD/MM/YYYY",
                  },
                  on: { change: _vm.handleDateRangeChange },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-group" },
              [
                _c("label", { staticClass: "filter-label" }, [
                  _vm._v("Atanan Kişiler:"),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "280px" },
                    attrs: {
                      mode: "multiple",
                      placeholder: "Kullanıcı seçiniz",
                    },
                    on: { change: _vm.handleAssigneesChange },
                    model: {
                      value: _vm.selectedAssignees,
                      callback: function ($$v) {
                        _vm.selectedAssignees = $$v
                      },
                      expression: "selectedAssignees",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { value: "notAppointed" } },
                      [_vm._v("Atanmamış")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filteredUsersAvatar, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(user.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-group" },
              [
                _c("label", { staticClass: "filter-label" }, [
                  _vm._v("Öncelik:"),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "200px" },
                    attrs: { mode: "multiple", placeholder: "Öncelik seçiniz" },
                    on: { change: _vm.handlePrioritiesChange },
                    model: {
                      value: _vm.selectedPriorities,
                      callback: function ($$v) {
                        _vm.selectedPriorities = $$v
                      },
                      expression: "selectedPriorities",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: "highest" } }, [
                      _vm._v("Highest"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "high" } }, [
                      _vm._v("High"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "medium" } }, [
                      _vm._v("Medium"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "low" } }, [
                      _vm._v("Low"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "lowest" } }, [
                      _vm._v("Lowest"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "reports-content" }, [
      !_vm.selectedWorkflowId
        ? _c("div", { staticClass: "no-workflow-selected" }, [_vm._m(0)])
        : _vm.isLoading
        ? _c("div", { staticClass: "loading-state" }, [
            _c("div", { staticClass: "custom-loading" }, [
              _c(
                "svg",
                {
                  staticClass: "loading-svg",
                  attrs: {
                    viewBox: "0 0 120 120",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("circle", {
                    staticClass: "loading-circle-bg",
                    attrs: {
                      cx: "60",
                      cy: "60",
                      r: "50",
                      fill: "none",
                      stroke: "#e5e7eb",
                      "stroke-width": "6",
                    },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "loading-circle-progress",
                    attrs: {
                      cx: "60",
                      cy: "60",
                      r: "50",
                      fill: "none",
                      stroke: "#3b82f6",
                      "stroke-width": "6",
                      "stroke-linecap": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("g", { staticClass: "task-icons" }, [
                    _c("rect", {
                      attrs: {
                        x: "40",
                        y: "35",
                        width: "40",
                        height: "50",
                        rx: "4",
                        fill: "#f8fafc",
                        stroke: "#cbd5e1",
                        "stroke-width": "1.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "45",
                        y: "42",
                        width: "8",
                        height: "8",
                        rx: "1",
                        fill: "#10b981",
                        stroke: "#10b981",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M47 45 L49 47 L52 44",
                        stroke: "white",
                        "stroke-width": "1.5",
                        fill: "none",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        x1: "56",
                        y1: "46",
                        x2: "72",
                        y2: "46",
                        stroke: "#374151",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "45",
                        y: "54",
                        width: "8",
                        height: "8",
                        rx: "1",
                        fill: "#10b981",
                        stroke: "#10b981",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M47 57 L49 59 L52 56",
                        stroke: "white",
                        "stroke-width": "1.5",
                        fill: "none",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        x1: "56",
                        y1: "58",
                        x2: "70",
                        y2: "58",
                        stroke: "#374151",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "45",
                        y: "66",
                        width: "8",
                        height: "8",
                        rx: "1",
                        fill: "white",
                        stroke: "#cbd5e1",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        x1: "56",
                        y1: "70",
                        x2: "68",
                        y2: "70",
                        stroke: "#9ca3af",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "45",
                        y: "78",
                        width: "8",
                        height: "8",
                        rx: "1",
                        fill: "white",
                        stroke: "#cbd5e1",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        x1: "56",
                        y1: "82",
                        x2: "65",
                        y2: "82",
                        stroke: "#9ca3af",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "floating-dot dot-1",
                    attrs: { cx: "25", cy: "30", r: "3", fill: "#f59e0b" },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "floating-dot dot-2",
                    attrs: { cx: "95", cy: "40", r: "2.5", fill: "#8b5cf6" },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "floating-dot dot-3",
                    attrs: { cx: "20", cy: "90", r: "2", fill: "#ef4444" },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "floating-dot dot-4",
                    attrs: { cx: "100", cy: "85", r: "3", fill: "#10b981" },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ])
        : _vm.reportData
        ? _c("div", { staticClass: "reports-data" }, [
            _c("div", { staticClass: "stats-cards" }, [
              _c("div", { staticClass: "stat-card completed" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "stat-content" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.dateRangeText)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(
                      _vm._s(_vm.reportData.dateRangeStats.completedTasks) +
                        " görev kapatıldı"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card updated" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "stat-content" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.dateRangeText)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(
                      _vm._s(_vm.reportData.dateRangeStats.updatedTasks) +
                        " görev güncellendi"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card created" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "stat-content" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(_vm.dateRangeText)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(
                      _vm._s(_vm.reportData.dateRangeStats.createdTasks) +
                        " görev oluşturuldu"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-card deadline" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "stat-content" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("Yaklaşan Deadlinelar"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.upcomingDeadlineText)),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "report-cards" }, [
              _c("div", { staticClass: "report-card pipeline-overview" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "chart-container" }, [
                    _c("div", { staticClass: "simple-pie-chart" }, [
                      _c("div", { staticClass: "pie-container" }, [
                        _c(
                          "div",
                          {
                            staticClass: "pie-chart",
                            style: { background: _vm.pieChartGradient },
                          },
                          [
                            _c("div", { staticClass: "pie-center" }, [
                              _c("div", { staticClass: "total-number" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.reportData.statusOverview.totalTasks
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "total-label" }, [
                                _vm._v("Toplam bilet"),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "legend" },
                      _vm._l(_vm.legendItems, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "legend-item",
                            style: { animationDelay: index * 0.1 + "s" },
                          },
                          [
                            _c("div", {
                              staticClass: "legend-color",
                              style: { backgroundColor: item.color },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "legend-text" }, [
                              _c("span", { staticClass: "legend-label" }, [
                                _vm._v(_vm._s(item.label) + ":"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "legend-value" }, [
                                _vm._v(_vm._s(item.value)),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "report-card priority-overview" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "bar-chart-container" }, [
                    _c("div", { staticClass: "chart-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "y-axis" },
                        _vm._l(_vm.yAxisTicks, function (tick) {
                          return _c(
                            "div",
                            { key: tick, staticClass: "y-label" },
                            [_vm._v(_vm._s(tick))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "chart-area" }, [
                        _c(
                          "div",
                          { staticClass: "grid-lines" },
                          _vm._l(_vm.yAxisTicks, function (tick) {
                            return _c("div", {
                              key: tick,
                              staticClass: "grid-line",
                            })
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "bars-container" },
                          _vm._l(_vm.priorityChartData, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "bar-item",
                                style: { animationDelay: index * 0.1 + "s" },
                              },
                              [
                                _c("div", { staticClass: "bar-wrapper" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bar",
                                      class: item.priority,
                                      style: {
                                        height: item.heightPercentage + "%",
                                        backgroundColor: item.color,
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "bar-value" }, [
                                        _vm._v(_vm._s(item.count)),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bar-label" }, [
                                  _vm._v(_vm._s(item.label)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "report-cards" }, [
              _c("div", { staticClass: "report-card team-workload" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c(
                    "div",
                    { staticClass: "team-list" },
                    _vm._l(_vm.teamWorkloadData, function (member, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content:
                                  member.user.name +
                                  ": " +
                                  member.taskCount +
                                  " görev (" +
                                  member.percentage +
                                  "%)",
                                placement: "top",
                              },
                              expression:
                                "{\n                                    content: `${member.user.name}: ${member.taskCount} görev (${member.percentage}%)`,\n                                    placement: 'top'\n                                }",
                            },
                          ],
                          key: index,
                          staticClass: "team-member",
                          style: { animationDelay: index * 0.1 + "s" },
                        },
                        [
                          _c("div", { staticClass: "member-info" }, [
                            _c("div", { staticClass: "member-avatar" }, [
                              member.user.gravatar
                                ? _c("img", {
                                    staticClass: "avatar-image",
                                    attrs: {
                                      src: member.user.gravatar,
                                      alt: member.user.name,
                                    },
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass: "avatar-placeholder",
                                      class: { unassigned: !member.userId },
                                    },
                                    [
                                      member.userId
                                        ? _c(
                                            "span",
                                            { staticClass: "avatar-initials" },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.getInitials(
                                                      member.user.name
                                                    )
                                                  ) +
                                                  "\n                                            "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons unassigned-icon",
                                            },
                                            [_vm._v("person_off")]
                                          ),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "member-details" }, [
                              _c("div", { staticClass: "member-name" }, [
                                _vm._v(_vm._s(member.user.name)),
                              ]),
                              _vm._v(" "),
                              member.user.email
                                ? _c("div", { staticClass: "member-email" }, [
                                    _vm._v(_vm._s(member.user.email)),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "workload-info" }, [
                            _c("div", { staticClass: "workload-percentage" }, [
                              _vm._v(_vm._s(member.percentage) + "%"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "workload-bar" }, [
                              _c("div", {
                                staticClass: "workload-progress",
                                style: {
                                  width: member.percentage + "%",
                                  backgroundColor: _vm.getWorkloadColor(
                                    member.percentage
                                  ),
                                },
                              }),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm.error
        ? _c("div", { staticClass: "error-state" }, [
            _c(
              "div",
              { staticClass: "error-content" },
              [
                _c("span", { staticClass: "material-icons error-icon" }, [
                  _vm._v("error"),
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Rapor Yüklenirken Hata Oluştu")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.error))]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.loadReports },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("refresh"),
                    ]),
                    _vm._v(
                      "\n                    Tekrar Dene\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-state" }, [
      _c("span", { staticClass: "material-icons empty-icon" }, [
        _vm._v("bar_chart"),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Rapor Görüntülemek İçin Workflow Seçin")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Görev raporlarını görüntülemek için yukarıdan bir workflow seçiniz."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-text" }, [
      _c("div", { staticClass: "loading-title" }, [
        _vm._v("Rapor Hazırlanıyor"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "loading-subtitle" }, [
        _vm._v("Görev verileri analiz ediliyor..."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("done_all")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("update")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("add_task")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("schedule")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h3", { staticClass: "card-title" }, [_vm._v("Durum genel bakışı")]),
        _vm._v(" "),
        _c("p", { staticClass: "card-subtitle" }, [
          _vm._v("Biletlerinizin durumunu anlık olarak görün."),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-icon" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("donut_large")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h3", { staticClass: "card-title" }, [_vm._v("Öncelik Dağılımı")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-icon" }, [
        _c("span", { staticClass: "material-icons" }, [
          _vm._v("priority_high"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h3", { staticClass: "card-title" }, [_vm._v("Takım iş yükü")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-icon" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("groups")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }